import { createSelector } from "reselect";

export const remoteSelector = state => state.remote;

export const isLoadingSelector = createSelector(
  remoteSelector,
  remote => remote.loading === true
);
